import { selectorFamily } from "recoil";
import {
  GREYED_OUT_FOCUS_AREA_OPACITY,
  SELECTED_FOCUS_AREA_OPACITY,
} from "../layerDefs";
import { selectedFocusAreaAtom } from "../../map/selectedRegionAtoms";
import { layerDefSourceDataSelector } from "./layerDefSourceDataSelector";
import { layerDefsAtomFamily } from "../layerDefsAtoms";
import { focusAreaLayerIdSelector } from "../../map/focusAreaLayerAtoms";

export const layerDefFormatSelector = selectorFamily({
  key: "layer-format-selector",
  get:
    (layerID) =>
    ({ get }) => {
      const layerDef = get(layerDefsAtomFamily(layerID));
      let sourceData = get(layerDefSourceDataSelector(layerID));
      const focusAreaLayerId = get(focusAreaLayerIdSelector)

      if (!sourceData && layerDef.customFetch && layerDef.source.type === 'geojson') {
        sourceData = {
          type: "FeatureCollection",
          features: [],
        }
      }

      if (!sourceData && layerDef.source.type !== "vector") {
        return null;
      }

      let source;
      if (layerDef.layer.type === "raster") {
          source = {
              ...layerDef.source,
          };
      } else if (layerDef.source.type === "vector") {
          source = layerDef.source;
      } else {
          source = {
              ...layerDef.source,
              data: sourceData,
            }
      }

      if (layerID === focusAreaLayerId) {
        const selectedFocusArea = get(selectedFocusAreaAtom);
        const objectid = selectedFocusArea?.properties?.objectid;

        if (!objectid) {
          return newLayer(source, layerDef.layer, layerDef.overLayers);
        }

        const fillOpacity = [
          "case",
          ["==", ["get", "objectid"], objectid],
          SELECTED_FOCUS_AREA_OPACITY,
          GREYED_OUT_FOCUS_AREA_OPACITY,
        ];

        return newLayer(
          source,
          applyLayerOpacity(layerDef.layer, fillOpacity),
          layerDef.overLayers?.map((ol) => applyLayerOpacity(ol, fillOpacity))
        )
      }

      return newLayer(source, layerDef.layer, layerDef.overLayers);
    },
});

const newLayer = (source, layer, overLayers=undefined) => {
  const l = {
    source,
    layer,
  }

  if (overLayers) {
    l.overLayers = overLayers
  }

  return l
}

const applyLayerOpacity = (layer, newOpacity) => {

  if (layer.type === 'fill') {
    return {
      ...layer,
      paint: {
        ...layer?.paint,
        "fill-opacity": newOpacity,
      },
    }
  }

  return {
    ...layer,    
  }
}